<div class="main_body">
    <app-page-header
      title="セクショングループ・セクション まとめて作成"
      i18n-title="@@adminSystem.createSectionGroupAndSection.title.bulkCreate"
      subtitle="セクショングループ・セクショングループ管理者・セクション・セクション管理スタッフをまとめて作成します"
      i18n-subtitle="@@adminSystem.createSectionGroupAndSection.label.description"
      backLabel="セクショングループ"
      i18n-backLabel="@@adminSystem.createSectionGroupAndSection.nav.backToList"
      backIcon="corporate_fare"
      [useHistoryBack]="true"
      icon="section-group"
    />
    <div class="contents">
      <div class="contents_section_group">
        <section class="contents__section" #contentsSection>
          <div class="stepper-container">

            <!-- Sidebar Navigation -->
            <nav class="stepper-sidebar" aria-label="ステップナビゲーション">
              <button type="button"
                      class="stepper-sidebar__step"
                      [class.stepper-sidebar__step--active]="currentStepIndex() === 0"
                      [class.stepper-sidebar__step--completed]="currentStepIndex() > 0"
                      (click)="goToStep(0)">
                <span class="stepper-sidebar__num"
                      [class.stepper-sidebar__num--active]="currentStepIndex() === 0"
                      [class.stepper-sidebar__num--completed]="currentStepIndex() > 0">1</span>
                <span class="stepper-sidebar__label"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.sectionGroupInfo">セクショングループ情報</span>
              </button>
              <button type="button"
                      class="stepper-sidebar__step"
                      [class.stepper-sidebar__step--active]="currentStepIndex() === 1"
                      [class.stepper-sidebar__step--completed]="currentStepIndex() > 1"
                      (click)="goToStep(1)"
                      [disabled]="currentStepIndex() < 1">
                <span class="stepper-sidebar__num"
                      [class.stepper-sidebar__num--active]="currentStepIndex() === 1"
                      [class.stepper-sidebar__num--completed]="currentStepIndex() > 1">2</span>
                <span class="stepper-sidebar__label"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.sectionInfo">セクション情報</span>
              </button>
              <button type="button"
                      class="stepper-sidebar__step"
                      [class.stepper-sidebar__step--active]="currentStepIndex() === 2"
                      [class.stepper-sidebar__step--completed]="currentStepIndex() > 2"
                      (click)="goToStep(2)"
                      [disabled]="currentStepIndex() < 2">
                <span class="stepper-sidebar__num"
                      [class.stepper-sidebar__num--active]="currentStepIndex() === 2"
                      [class.stepper-sidebar__num--completed]="currentStepIndex() > 2">3</span>
                <span class="stepper-sidebar__label"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.adminInfo">管理者情報</span>
              </button>
              <button type="button"
                      class="stepper-sidebar__step"
                      [class.stepper-sidebar__step--active]="currentStepIndex() === 3"
                      (click)="goToStep(3)"
                      [disabled]="currentStepIndex() < 3">
                <span class="stepper-sidebar__num"
                      [class.stepper-sidebar__num--active]="currentStepIndex() === 3">4</span>
                <span class="stepper-sidebar__label"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.create">作成</span>
              </button>
            </nav>

            <!-- Step Content -->
            <div class="step-content">

              <!-- ===== Step 1: セクショングループ情報 ===== -->
              <!-- サブフォームは @if で破棄せず [hidden] で隠す。
                  破棄すると戻ってくるたびに再初期化され、プレビューや取得済みの代理店情報などが失われるため -->
              <div [hidden]="currentStepIndex() !== 0">
                <div class="step-content__header">
                  <mat-icon class="step-content__icon">corporate_fare</mat-icon>
                  <h2 class="step-content__title"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.sectionGroupInfo">セクショングループ情報</h2>
                </div>

                <div class="step-content__form">
                  <app-section-group-form #sgForm
                    [form]="sectionGroupFormGroup"
                    [mode]="Mode.create"
                    [sectionGroupId]="null"
                    [sectionGroupData]="sectionGroupData"
                    [userDataTemplates]="userDataTemplates"
                    [warnOnUserDataAttributesChange]="false">
                  </app-section-group-form>

                  <!-- Actions -->
                  <div class="step-actions">
                    <button mat-stroked-button type="button" (click)="clearForm(sectionGroupFormGroup)">
                      <mat-icon>restart_alt</mat-icon>
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.clear">クリア</span>
                    </button>
                    <div class="step-actions__spacer"></div>
                    <button mat-flat-button type="button" color="primary" (click)="nextStep()">
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.next">次へ</span>
                      <mat-icon>arrow_forward</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- ===== Step 2: セクション情報 ===== -->
              <!-- サブフォームは @if で破棄せず [hidden] で隠す（Step 1 と同じ理由） -->
              <div [hidden]="currentStepIndex() !== 1">
                <div class="step-content__header">
                  <mat-icon class="step-content__icon">apartment</mat-icon>
                  <h2 class="step-content__title"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.sectionInfo">セクション情報</h2>
                </div>

                <div class="step-content__form">
                  <app-section-details-form #sectionDetailsForm
                    [form]="sectionFormGroup"
                    [sectionId]="null">

                    <!-- 住所ラベル横に「グループからコピー」ボタンを差し込む -->
                    <button addressExtra mat-stroked-button type="button" class="copy-btn" (click)="copyAddressFromGroupToSection()">
                      <mat-icon>content_copy</mat-icon>
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.copyFromGroup">グループからコピー</span>
                    </button>

                  </app-section-details-form>

                  <!-- Actions -->
                  <div class="step-actions">
                    <button mat-stroked-button type="button" (click)="prevStep()">
                      <mat-icon>arrow_back</mat-icon>
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.back">戻る</span>
                    </button>
                    <button mat-stroked-button type="button" (click)="clearForm(sectionFormGroup)">
                      <mat-icon>restart_alt</mat-icon>
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.clear">クリア</span>
                    </button>
                    <div class="step-actions__spacer"></div>
                    <button mat-flat-button type="button" color="primary" (click)="nextStep()">
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.next">次へ</span>
                      <mat-icon>arrow_forward</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- ===== Step 3: 管理者情報 ===== -->
              <!-- サブフォームは @if で破棄せず [hidden] で隠す（Step 1 と同じ理由） -->
              <div [hidden]="currentStepIndex() !== 2">
                <div class="step-content__header">
                  <mat-icon class="step-content__icon">manage_accounts</mat-icon>
                  <h2 class="step-content__title"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.adminInfo">管理者情報</h2>
                </div>

                <div class="step-content__form">
                  <app-section-group-admin-assignment #adminAssignmentComp
                    [selfAdminGroupLabel]="i18n.label.selfAdminGroupLabel"
                    [form]="adminAssignmentFormGroup">

                    <!-- 「自分自身を管理者として登録する」の直下に、セクション版のチェックボックスを差し込む -->
                    <label selfAdminExtra class="role-checkbox" [formGroup]="sectionAdminExtrasFormGroup">
                      <mat-checkbox formControlName="assignSelfAsSectionAdmin" color="primary"></mat-checkbox>
                      <span class="role-checkbox__label">{{ i18n.label.assignSelfAsSectionAdmin }}</span>
                    </label>

                    <!-- 「新規に管理者を追加する」のネスト部分に、グループ／セクションどちらに登録するかを差し込む -->
                    <div newAdminExtra class="role-checkboxes" [formGroup]="sectionAdminExtrasFormGroup"
                      role="group" [attr.aria-label]="i18n.label.newAdminGroupLabel">
                      <div class="role-checkboxes__title">{{ i18n.label.newAdminGroupLabel }}</div>
                      <label class="role-checkbox">
                        <mat-checkbox formControlName="registerAsGroupAdmin" color="primary"
                          (change)="onRegisterAsGroupAdminChange($event)"></mat-checkbox>
                        <span class="role-checkbox__label">{{ i18n.label.registerAsGroupAdmin }}</span>
                      </label>
                      <label class="role-checkbox">
                        <mat-checkbox formControlName="registerAsSectionAdmin" color="primary"
                          (change)="onRegisterAsSectionAdminChange($event)"></mat-checkbox>
                        <span class="role-checkbox__label">{{ i18n.label.registerAsSectionAdmin }}</span>
                      </label>
                    </div>

                  </app-section-group-admin-assignment>

                  <!-- Actions -->
                  <div class="step-actions">
                    <button mat-stroked-button type="button" (click)="prevStep()">
                      <mat-icon>arrow_back</mat-icon>
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.back">戻る</span>
                    </button>
                    <button mat-stroked-button type="button"
                      (click)="clearForm(adminAssignmentFormGroup, sectionAdminExtrasFormGroup)">
                      <mat-icon>restart_alt</mat-icon>
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.clear">クリア</span>
                    </button>
                    <div class="step-actions__spacer"></div>
                    <button mat-flat-button type="button" color="primary" (click)="nextStep()">
                      <span i18n="@@adminSystem.createSectionGroupAndSection.button.next">次へ</span>
                      <mat-icon>arrow_forward</mat-icon>
                    </button>
                  </div>
                </div>
              </div>

              <!-- ===== Step 4: 作成 ===== -->
              @if (currentStepIndex() === 3) {
                <div class="step-content__header">
                  <mat-icon class="step-content__icon">send</mat-icon>
                  <h2 class="step-content__title"
                      i18n="@@adminSystem.createSectionGroupAndSection.step.create">作成</h2>
                </div>

                <div class="submit-card">
                  <mat-icon class="submit-card__icon">playlist_add_check</mat-icon>
                  <p class="submit-card__text"
                    i18n="@@adminSystem.createSectionGroupAndSection.message.createConfirmation">
                    下記ボタンをクリックするとセクショングループ・セクションが作成され、管理者が割り当てられます
                  </p>
                </div>

                <div class="step-actions">
                  <button mat-stroked-button type="button" (click)="prevStep()">
                    <mat-icon>arrow_back</mat-icon>
                    <span i18n="@@adminSystem.createSectionGroupAndSection.button.backFinal">戻る</span>
                  </button>
                  <div class="step-actions__spacer"></div>
                  <button mat-flat-button type="button" color="primary" [disabled]="isSending()" (click)="createAll()">
                    @if (isSending()) {
                      <mat-spinner diameter="18"></mat-spinner>
                    } @else {
                      <mat-icon>check</mat-icon>
                    }
                    <span i18n="@@adminSystem.createSectionGroupAndSection.button.create">作成</span>
                  </button>
                </div>
              }

            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
